import { TransferRecommendationsContainer } from "./container";

export const TransferRecommendationsPage = () => {
  return <TransferRecommendationsContainer />;
};
